// stockMobileShared.js — helpers d'affichage communs aux écrans Stock mobile.
import { EVENT_COLORS } from "../../gestion-stock/StockProductHistory";

export const PERM = {
  transferView: "Gestion Commerciale.Stock.GestionStock.Transfer.view",
  transferDelete: "Gestion Commerciale.Stock.GestionStock.Transfer.delete",
  adjustView: "Gestion Commerciale.Stock.GestionStock.Adjust.view",
  adjustCreate: "Gestion Commerciale.Stock.GestionStock.Adjust.create",
  adjustEdit: "Gestion Commerciale.Stock.GestionStock.Adjust.edit",
  adjustDelete: "Gestion Commerciale.Stock.GestionStock.Adjust.delete",
};

const nfQty = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 5 });

export const fmtQty = (v) => (Number.isFinite(Number(v)) ? nfQty.format(Number(v)) : "-");

/** Quantité signée : « +12 » / « -3 ». */
export const fmtSigned = (v) => {
  const n = Number(v) || 0;
  return `${n > 0 ? "+" : ""}${nfQty.format(n)}`;
};

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString("fr-FR");
};

export const fmtDateTime = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return `${d.toLocaleDateString("fr-FR")} ${d.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

/** Statut d'un transfert → ton de `Pill` du kit .epm (GestionStock.jsx:848-854). */
export const transferPill = (status) => {
  switch (String(status || "")) {
    case "in_transit":
      return { tone: "draft", label: "En transit" };
    case "received":
      return { tone: "ok", label: "Reçu" };
    case "completed":
      return { tone: "ok", label: "Complété" };
    default:
      return { tone: "info", label: String(status || "—") };
  }
};

// Les couleurs desktop sont des noms de Tag AntD ; le kit .epm expose
// ok / info / warn / danger / cyan / draft / off.
const ANTD_TO_TONE = {
  green: "ok",
  lime: "ok",
  blue: "info",
  geekblue: "info",
  cyan: "cyan",
  gold: "draft",
  volcano: "warn",
  magenta: "warn",
  purple: "info",
  red: "danger",
};

/** Type d'événement du cycle de vie → ton de `Pill`. */
export const eventTone = (eventType) =>
  ANTD_TO_TONE[EVENT_COLORS[eventType]] || "off";
